import { createAuthStore, type AuthStatus } from '@jarvis/platform-ui';
import type { AssistantRole } from './roles';
import { getHighestAssistantRole } from './roles';

export type { AuthStatus };

interface AuthState {
  status: AuthStatus;
  username: string | null;
  displayName: string | null;
  roles: string[];
  highestAssistantRole: AssistantRole | null;
  setChecking: () => void;
  setAnonymous: () => void;
  setForbidden: () => void;
  setAuthenticated: (payload: {
    username: string | null;
    displayName: string | null;
    roles: string[];
  }) => void;
  reset: () => void;
}

export const useAuthStore = createAuthStore({
  highestRoleKey: 'highestAssistantRole',
  getHighestRole: getHighestAssistantRole
}) as unknown as import('zustand').UseBoundStore<import('zustand').StoreApi<AuthState>>;
